import { FC, useMemo } from "react";
import { Row } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import useMultiLanguage from "../../hook/useMultiLanguage";
import { findMenuAccessAllowed } from "../utils/functionUtils";
import { LIST_TAB } from "./constants/managerConsts";
import "./manager.scss"
import { KTSVG } from "../../../_metronic/helpers";

const Manager: FC = () => {
  const { lang } = useMultiLanguage();
  const defaultKey = useMemo(() => findMenuAccessAllowed(LIST_TAB)?.key, []);
  return (
    <Row className="manager spaces mt-16">
      <Tabs defaultActiveKey={defaultKey} id="uncontrolled-tab-example">
        {LIST_TAB.map(tab => (
          <Tab 
            eventKey={tab.key}
            title={
              <>
                {tab.icon && <KTSVG path={tab.icon} className="pe-2 text-primary" />}
                <span>{lang(tab.title)}</span>
              </>
            }
          >
            <tab.Component />
          </Tab>
        ))}
      </Tabs>
    </Row>
  );
};
export { Manager };
